import React from 'react';
import { CustomImageHandler } from '../../../../../../shared/components/CustomImageHandler';
import { TrashIcon } from '../../../../../../shared/Icons';
import { Company } from '../../../../../../model/user/Company';
import { UserRoles } from '../../../../../../enum/UserRoles';
import { Col, Row } from 'react-bootstrap';
import { User } from '../../../../../../model/user/User';

interface IAddManagingUserProps {
    company: Company;
    removeUser: (id: number) => void;
    companyMaster: User;
}

export function AddManagingUser({ company, removeUser, companyMaster }: IAddManagingUserProps) {
    const brandMaster = companyMaster
        ? companyMaster
        : company?.companyUsers?.find(item => item.userType === UserRoles.BRAND_MASTER);

    return (
        <Row className="align-items-center my-2">
            <Col md={4}>
                <div className="d-flex align-items-center">
                    <CustomImageHandler
                        photoPath={company?.profilePhoto?.path}
                        classes="default-radius img-cover mr-3"
                        style={{ width: '2rem', height: '2rem' }}
                        altTag="Campaign-logo"
                    />
                    <CustomImageHandler
                        photoPath={brandMaster?.profilePhoto?.path ?? ''}
                        classes="user-img-rounded"
                        altTag="User logo"
                        name={`${brandMaster?.firstName ?? ''} ${brandMaster?.lastName ?? ''}`}
                    />
                    <div className="d-flex flex-column ml-1">
                        <h6 className="mb-0">
                            {brandMaster?.firstName} {brandMaster?.lastName}
                        </h6>
                        <span className="text-primary">Admin Account</span>
                    </div>
                </div>
            </Col>
            <Col md={3}>
                <p className="mb-0 mr-3">
                    <i className="fi fi-rr-phone-call text-primary mr-1"></i>
                    {company?.contact?.phone ?? '-'}
                </p>
            </Col>
            <Col md={4}>
                <p aria-label="Email" className="mb-0">
                    <i className="fi fi-rr-envelope text-primary mr-1"></i>
                    {brandMaster?.email ?? '-'}
                </p>
            </Col>
            <Col onClick={() => removeUser(company?.id ?? 0)} md={1} className="text-end cursor-pointer">
                <TrashIcon width="15" height="16" classes="mr-2" />
            </Col>
        </Row>
    );
}
